export const DEFAULT_THEME = {
  brand_name: "CosmicLove",
  logo_type: "emoji",
  logo_value: "💫",
  colors: {
    bg: "#05030F",
    bg_glow: "#1B0B3A",
    accent_from: "#7B2FF7",
    accent_to: "#D14BF5",
    accent_secondary: "#38E8FF",
    text_primary: "#F3EEFF",
    text_secondary: "#9E8FC7",
    card_bg: "rgba(255,255,255,0.04)",
    card_border: "rgba(255,255,255,0.08)",
  },
  fonts: { heading: "Unbounded", body: "Manrope" },
  background_style: "stars",
  button_radius: "999px",
  card_radius: "20px",
};

const loadedFonts = new Set();

function loadGoogleFont(name) {
  if (!name || loadedFonts.has(name)) return;
  loadedFonts.add(name);
  const family = name.trim().replace(/ /g, "+");
  const href = `https://fonts.googleapis.com/css2?family=${family}:wght@400;500;600;700;800&display=swap`;
  const link = document.createElement("link");
  link.rel = "stylesheet";
  link.href = href;
  link.setAttribute("data-dynamic-font", name);
  document.head.appendChild(link);
}

// Apply a theme object to :root as CSS variables + load fonts dynamically.
export function applyTheme(theme) {
  if (!theme) return;
  const t = { ...DEFAULT_THEME, ...theme };
  const c = { ...DEFAULT_THEME.colors, ...(theme.colors || {}) };
  const f = { ...DEFAULT_THEME.fonts, ...(theme.fonts || {}) };
  const root = document.documentElement.style;

  root.setProperty("--bg", c.bg);
  root.setProperty("--bg-glow", c.bg_glow);
  root.setProperty("--accent-from", c.accent_from);
  root.setProperty("--accent-to", c.accent_to);
  root.setProperty("--accent-secondary", c.accent_secondary);
  root.setProperty("--gold", c.accent_secondary);
  root.setProperty("--text", c.text_primary);
  root.setProperty("--text-sec", c.text_secondary);
  root.setProperty("--glass", c.card_bg);
  root.setProperty("--glass-border", c.card_border);
  root.setProperty("--btn-radius", t.button_radius || "999px");
  root.setProperty("--card-radius", t.card_radius || "20px");

  const heading = f.heading || "Unbounded";
  const body = f.body || "Manrope";
  root.setProperty("--font-heading", `'${heading}', 'Manrope', system-ui, sans-serif`);
  root.setProperty("--font-body", `'${body}', system-ui, sans-serif`);
  loadGoogleFont(heading);
  loadGoogleFont(body);
}
